// extracted by mini-css-extract-plugin
export default {"light":"Button_light__-asRn","dark":"Button_dark__S5hJg"};